import React from 'react';
import type { QuoteFormData, QuoteFormErrors } from '../../types/quote';
import { MuiTextInput } from './MuiInputs';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

interface StepCustomerInfoProps {
  data: QuoteFormData;
  errors: QuoteFormErrors;
  onChange: (field: keyof QuoteFormData, value: string) => void;
}

export const StepCustomerInfo: React.FC<StepCustomerInfoProps> = ({
  data,
  errors,
  onChange,
}) => {
  return (
    <div className="space-y-6">
      <div className="border-b border-gray-100 pb-4">
        <span className="text-xs uppercase tracking-widest text-[#F55109] font-bold">
          Step 1 of 6
        </span>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C] special-header mt-1">
          SECTION 1 — CUSTOMER INFORMATION
        </h3>
        <p className="text-sm text-gray-500 mt-1">
          Tell us about yourself so we know who to prepare this custom transportation quote for.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
        {/* Full Name */}
        <MuiTextInput
          id="fullName"
          label="Full Name"
          value={data.fullName}
          onChange={(val) => onChange('fullName', val)}
          placeholder="e.g. Adebayo Ogunlesi"
          required
          errorMessage={errors.fullName}
          startIcon={<PersonOutlineIcon fontSize="small" />}
        />

        {/* Company Name */}
        <MuiTextInput
          id="companyName"
          label="Company Name (Optional)"
          value={data.companyName}
          onChange={(val) => onChange('companyName', val)}
          placeholder="e.g. Speed Distribution Ltd."
          startIcon={<BusinessIcon fontSize="small" />}
        />

        {/* Phone Number */}
        <MuiTextInput
          id="phoneNumber"
          label="Phone Number"
          type="tel"
          value={data.phoneNumber}
          onChange={(val) => onChange('phoneNumber', val)}
          placeholder="e.g. +1 (416) 555-0192"
          required
          errorMessage={errors.phoneNumber}
          startIcon={<PhoneIcon fontSize="small" />}
        />

        {/* Email Address */}
        <MuiTextInput
          id="email"
          label="Email Address"
          type="email"
          value={data.email}
          onChange={(val) => onChange('email', val)}
          placeholder="e.g. adebayo@speedyssey.com"
          required
          errorMessage={errors.email}
          startIcon={<EmailOutlinedIcon fontSize="small" />}
        />
      </div>
    </div>
  );
};
